






















































































import Vue, { PropOptions } from 'vue'
import DrawerMenu from '@/common/components/globalHeader/DrawerMenu.vue'
import ProfileModal from '@/common/components/globalHeader/ProfileModal.vue'
import { CommonAppData } from '@/common/types/commonAppData'
import { CurrentUser } from '@raksul/raksul-common-ui'

export default Vue.extend({
  components: {
    DrawerMenu,
    ProfileModal
  },
  props: {
    applicationData: {
      type: Object,
      required: true
    } as PropOptions<CommonAppData>,
    currentUser: {
      required: true,
      validator: v => typeof v === 'object' || v === null
    } as PropOptions<CurrentUser>,
    orderHistoryCount: {
      type: Number,
      required: true
    }
  },
  data(): {
    menuVisible: boolean
    profileModalVisible: boolean
  } {
    return {
      menuVisible: false,
      profileModalVisible: false
    }
  },
  methods: {
    toggleMenu() {
      this.menuVisible = !this.menuVisible
      if (this.menuVisible) {
        this.disablePageScroll()
      } else {
        this.enablePageScroll()
      }
    },
    disablePageScroll() {
      document.querySelector('body')!.classList.add('is-locked')
    },
    enablePageScroll() {
      document.querySelector('body')!.classList.remove('is-locked')
    },
    toggleProfileModal() {
      this.profileModalVisible = !this.profileModalVisible
      if (this.profileModalVisible) {
        this.disablePageScroll()
      } else {
        this.enablePageScroll()
      }
    }
  }
})
